import Icon from '../components/Icon.vue'

Icon.register({
  'skiing-nordic': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M336 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM552 416c13.2 0 24 10.8 24 24 0 39.7-32.3 72-72 72h-480c-13.2 0-24-10.7-24-24s10.8-24 24-24h42.9l54.1-270.8c-0.7-0.8-1.7-1.2-2.4-2.1-10.8-14.1-8.1-34.2 5.9-44.9l39.7-30.4c23-17.6 52.5-23.9 80.8-17.1l71.2 21.2c26.3 6.7 49.3 25.4 61.8 50.9l26.1 53.2h44c17.7 0 32 14.3 32 32 0 13.4-8.4 24.9-20.1 29.6l-25.5 178.4h69.5c13.2 0 24-10.8 24-24 0-13.3 10.8-24 24-24zM291.5 464l25.5-81.2-85-50.2c-27.6-16.3-38.9-50.8-26.3-80.3l37.5-87.4-14.7-4.4c-7.9-1.9-17.6 0.2-25.3 6.1l-39.7 30.4c-3.6 2.7-7.6 4.6-11.7 5.6l-52.3 261.4h24.2l62.5-131.8c7.6 10.9 17.4 20.6 29.5 27.8l22 13-43.1 91h96.9zM402.1 464l25.2-176h-33.3c-18.2 0-35.1-10.6-43.1-26.9l-20.3-41.4-31.3 78.3 61.2 36.1c18.7 11.3 27.5 33.6 21.6 54.4l-23.6 75.5h43.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/skiing-nordic.js
// module id = 1896
// module chunks = 0